import { FC, PropsWithChildren } from 'react';

import { dom } from 'app/utils';
import { IComponent } from '../types';

export interface IRow extends PropsWithChildren<IComponent> {
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch';
  justify?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly';
}

export const Row: FC<IRow> = ({ id, className, style, disabled, align, justify, children }) => {
  const row = { id, style, disabled,
    className: dom.className('i-component', 'i-row', className),
  };
  const container: any = { children,
    className: dom.className('i-container', 'flex', 'flex-row', { [`align-items-${align}`]: align, [`justify-content-${justify}`]: justify }),
  }

  return (
    <div { ...row }>
      <div { ...container } />
    </div>
  );
};
